export default "__VITE_ASSET__BnFBXVS6__"